// extracted by mini-css-extract-plugin
export default {"wrapperMiniMap":"MiniMap_wrapperMiniMap__ZjSgT"};